import { render, staticRenderFns } from "./ViewerCard.vue?vue&type=template&id=56377349&scoped=true"
import script from "./ViewerCard.vue?vue&type=script&lang=js"
export * from "./ViewerCard.vue?vue&type=script&lang=js"
import style0 from "./ViewerCard.vue?vue&type=style&index=0&id=56377349&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56377349",
  null
  
)

export default component.exports